<template>
  <div>

    <h2 style="margin-top: 10px; margin-bottom: 50px; text-align: center;">Good news, {{getName(name).first}}!</h2>
    <div class="tile is-parent" style="max-width: 500px; margin: auto;">
      <article class="tile is-child box" style="box-shadow: 0 2px 8px 4px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);">
        <div class="content">
          <div id="check" />
          <p style="color: #737373; text-align: center; font-variant-caps: small-caps;">Your business has been approved for:</p>
          <p class="title" style="text-align: center;">${{numberWithCommas(approval.amount, true)}}</p>
          <hr />
          <div class="level is-mobile">
            <div class="level-left">
              <strong>Term</strong>
            </div>
            <div class="level-right">{{approval.term}} months</div>
          </div>
          <div class="level is-mobile">
            <div class="level-left">
              <strong>Daily Payment*</strong>
            </div>
            <div class="level-right">${{numberWithCommas(approval.daily_payment, true)}}</div>
          </div>
        </div>
      </article>
    </div>
    <p style="text-align: center;">*Daily payment is estimated</p>
    <div class="buttons is-centered" style="margin-top: 30px;">
      <a class="button is-link green padded-button next-button" @click="next">Withdraw Funds</a>
    </div>
    <p style="text-align: center;">
      <a class="is-link" @click="next">I'm not happy with this offer.</a>
    </p>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";
export default {
  name: "OfferApproval",
  components: {},
  props: {
    approval: Object,
    name: String
  },
  mixins: [ApplyPage],
  methods: {
    numberWithCommas(val, money = false) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    getName(name) {
      console.log('getname', name)
      var customer_name = name;
      //lowercase all
      var formatted_pieces = customer_name.toLowerCase().split(" ");
      //strip prefix
      Array(
        "mr.",
        "ms.",
        "mrs.",
        "miss.",
        "dr.",
        "mr",
        "ms",
        "mrs",
        "miss"
      ).forEach(function(i, v) {
        //this assumes the array only offers prefixes
        if (formatted_pieces.indexOf(i) >= 0) {
          //found; shift
          formatted_pieces.shift();
        }
      });
      var lname = "";
      var fname = formatted_pieces[0].toLowerCase();
      for (var i = 1; i < formatted_pieces.length; i++) {
        if (formatted_pieces[i].indexOf(",") >= 0) {
          lname = formatted_pieces[i];
          break;
        }
        if (i == formatted_pieces.length - 1) {
          lname = formatted_pieces[i];
        }
      }
      lname = lname.replace(",", "").toLowerCase();
      lname = lname.charAt(0).toUpperCase() + lname.slice(1);
      fname = fname.charAt(0).toUpperCase() + fname.slice(1);
      return { first: fname, last: lname };
    }
  },
  data() {
    return {};
  },
  mounted: function() {

    var animation = lottie.loadAnimation({
      container: document.getElementById('check'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '../animations/GreenCheck.json' // the path to the animation json
    });
    setTimeout(function() {
      animation.play()
    }, 500)
    for (var i = 0; i < 80; i++) {
      create(i);
    }

    function create(i) {
      var width = Math.random() * 20;
      var height = width * 0.4;
      var colour = "green";

      $('<div class="confetti-' + i + " " + colour + '"></div>')
        .css({
          width: width + "px",
          height: height + "px",
          top: -Math.random() * 20 + "%",
          left: Math.random() * 100 + "%",
          opacity: Math.random() + 0.5,
          transform: "rotate(" + Math.random() * 360 + "deg)"
        })
        .appendTo("#app");
      drop(i);
    }

    function drop(x) {
      $(".confetti-" + x).animate(
        {
          top: "100%",
          left: "+=" + Math.random() * 15 + "%"
        },
        Math.random() * 3000 + 2000,
        function() {
          $(".confetti-" + x).remove();
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}

.green {
  background-color: #3cb968 !important;
}

.level {
  margin-bottom: 10px !important;
}

#check {
  max-width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 5px;
  margin-top: -60px;
}
</style>
